Vendd.Scripts.load(function () {

    var $wrapper = $('.side-menu');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    wrapper.open = function () {
        $('.mobile-title', $wrapper).addClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass('icon-plus').addClass('icon-minus');
        $('.nav-1', $wrapper).addClass('active');
    };

    wrapper.close = function () {
        $('.mobile-title', $wrapper).removeClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass('icon-minus').addClass('icon-plus');
        $('.nav-1', $wrapper).removeClass('active');
    };
    
    $wrapper.on('click', '.mobile-title', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('active')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });

    $wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', function (e) {
        wrapper.close();
    });
});

